import React from 'react';
import { CheckList } from './CheckList';
import type { Volume, VolumeTone } from '../types/content';
const toneBg: Record<VolumeTone, string> = {
  white: 'bg-white',
  mint: 'bg-seafoam-light',
  sand: 'bg-sand'
};
interface VolumeBlockProps {
  volume: Volume;
  total: number;
}
export function VolumeBlock({
  volume,
  total
}: VolumeBlockProps) {
  const cardBg = volume.tone === 'white' ? 'bg-sand-light' : 'bg-white';
  return <article className={`${toneBg[volume.tone]} py-20 px-4 border-t border-line`} aria-labelledby={`volume-${volume.number}`} data-id="element-331" data-mp="1qepylka5pgo7">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-[5fr_7fr] gap-10 lg:gap-14 items-start" data-id="element-332" data-mp="1hlupgfhkj0t5">
        <div data-id="element-333" data-mp="1lng7ef8ym5a7">
          <div className="flex items-center gap-3 mb-4" data-id="element-334" data-mp="1lmy3qxjywos9">
            <span className="font-display font-black text-orange text-lg" data-id="element-335" data-mp="1lldarcdaxdwi">
              {volume.number} OF {total}
            </span>
            <span className="h-px w-8 bg-line" aria-hidden="true" data-id="element-336" data-mp="2e3ip3180ewbf" />
            <span className="px-3 py-1 rounded-full bg-seafoam text-forest-dark text-xs font-bold tracking-wide" data-id="element-337" data-mp="2e5va5n92dmsp">
              VOLUME {volume.number}
            </span>
          </div>
          <h3 id={`volume-${volume.number}`} className="text-3xl md:text-4xl font-display font-extrabold leading-tight text-forest mb-4" data-id="element-338" data-mp="pv014abdjnkb">
            {volume.title}
          </h3>
          <p className="text-xl font-semibold text-navy mb-6" data-id="element-339" data-mp="zpjm7ncqx74f">{volume.tagline}</p>
          <div className="space-y-3 text-lg text-muted leading-relaxed" data-id="element-340" data-mp="1dgy6rymaxgdl">
            {volume.intro.map(p => <p key={p} data-id="element-341" data-mp="19j8x6vg1gdp3">{p}</p>)}
          </div>
          {volume.highlight && <div className="mt-5" data-id="element-342" data-mp="1neuoxadnpbl7">
              <p className="text-2xl md:text-3xl font-display font-black text-navy" data-id="element-343" data-mp="1ihcgrm7gr0e9">
                <span className="text-orange" data-id="element-344" data-mp="3p824mkx6lv7m">150</span>{' '}
                {volume.highlight.title.replace(/^150\s/, '').toUpperCase()}
              </p>
              <p className="text-lg text-muted mt-1" data-id="element-345" data-mp="3kas7ej3jwf98">{volume.highlight.note}</p>
            </div>}
        </div>

        <div className={`${cardBg} rounded-2xl border border-line shadow-sm p-6 md:p-8 flex flex-col gap-8`} data-id="element-346" data-mp="1o85iuixlzbg3">
          {volume.lists.map(list => <CheckList key={list.label} list={list} data-id="element-347" data-mp="1x5po02yldrvz" />)}
          <div className="rounded-xl bg-forest p-5 mt-auto" data-id="element-348" data-mp="225lt65j0zpd4">
            <span className="text-seafoam font-bold block mb-1" data-id="element-349" data-mp="22759tx8lg2ff">Result:</span>
            <p className="text-white text-base font-medium" data-id="element-350" data-mp="2745fw85g156j">{volume.result}</p>
            {volume.closing && <ul className="mt-4 pt-4 border-t border-white/15 flex flex-wrap gap-x-5 gap-y-1" data-id="element-351" data-mp="2c2gqwm7h5lqc">
                {volume.closing.map(line => <li key={line} className="text-white/85 text-sm font-semibold" data-id="element-352" data-mp="2kw3ie04ng2tq">
                    {line}
                  </li>)}
              </ul>}
          </div>
        </div>
      </div>
    </article>;
}